//
//
//
//
//
//
//
//
//

 
export default {
    onShareAppMessage () {
        const option = {
            title: `${process.env.APP_NAME}-新手购房网络登记指南`,
            path: '/reg_step/main'
        }
        return this.getShareInfo(option)
    },

}
